// All photo assets for the site.
// "I Maestri" (Platone) and "Stelle" (Buddha) rooms have real photos.
// "Vesuvio" and "Suite" rooms + Casa dei Maestri use placeholders until the owner provides photos.

export const LOGO = "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/5zgz8jix_DSC_8559.jpg";

// Real photos of the "I Maestri" room (B&B)
const MAESTRI_ROOM_PHOTOS = [
  "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/2s14oigr_1.jpeg",
  "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/s1m5dq19_2.jpeg",
  "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/sqcgzcoy_3.jpeg",
  "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/ejw4z5sd_4.jpeg",
  "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/3gco4w30_5.jpeg",
  "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/b49yhrfo_8.jpeg",
  "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/3hwx5c6f_9.jpeg",
  "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/614bzt6c_10.jpeg",
  "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/yzvf4duy_11.jpeg",
  "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/e6n5gydr_13.jpeg"
];

// Real photos of the "Stelle" room (B&B) - day + night
const STELLE_ROOM_PHOTOS = [
  // Day photos
  "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/b5ud6i24_2.jpeg",
  "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/0zgpaclt_3.jpeg",
  "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/zg5bdcpn_4.jpeg",
  "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/sde1plrj_7.jpeg",
  "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/acvthtse_11.jpeg",
  // Night photos
  "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/ejphanrq_8.jpeg",
  "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/ludutugn_9.jpeg",
  "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/fafgvmec_10.jpeg",
  "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/l3zw9e93_12.jpeg"
];

export const HERO_IMAGE = MAESTRI_ROOM_PHOTOS[0];

export const ROOMS_DATA = {
  platone: {
    cover: MAESTRI_ROOM_PHOTOS[0],
    gallery: MAESTRI_ROOM_PHOTOS
  },
  stelle: {
    cover: STELLE_ROOM_PHOTOS[0],
    gallery: STELLE_ROOM_PHOTOS
  },
  vesuvio: {
    cover: "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/7p2f3uyo_1.jpeg",
    gallery: [
      // Day photos
      "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/7p2f3uyo_1.jpeg",
      "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/seref0ek_2.jpeg",
      "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/3de9erj1_3.jpeg",
      "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/cgvlbk32_5.jpeg",
      "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/q708z0mm_6.jpeg",
      // Night photos
      "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/nd3fzrjx_7.jpeg",
      "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/4n7v4iqc_8.jpeg",
      "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/m85umho9_9.jpeg",
      "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/1gwmu3r5_10.jpeg",
      "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/8vivpa55_11.jpeg"
    ]
  },
  suite: {
    cover: "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/pj5mdlm7_13.jpeg",
    gallery: [
      // Day
      "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/pj5mdlm7_13.jpeg",
      "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/rgfqc6c6_15.jpeg",
      "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/sl3m7cb8_5.jpeg",
      "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/b958wn50_8.jpeg",
      "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/p9pr112p_9.jpeg",
      // Night
      "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/c2gu5xbq_2.jpeg",
      "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/07v2xjao_7.jpeg",
      "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/chnrdipl_10.jpeg",
      "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/fkztvgq2_11.jpeg",
      "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/6pjqe3b0_12.jpeg"
    ]
  }
};

export const CASA_PHOTOS = [
  "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/qu1q2w4t_2.jpeg",
  "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/d694kuqe_21.jpeg",
  "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/f3pq1m6u_3.jpeg",
  "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/dzmsrnll_12.jpeg",
  "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/l8gvm8m4_13.jpeg",
  "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/aartt8z6_17.jpeg",
  "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/ifuabuew_4.jpeg",
  "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/mcdebr6g_18.jpeg",
  "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/pb0whuec_10.jpeg",
  "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/x6kl6gbw_19.jpeg",
  "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/sbwhsmu8_20.jpeg",
  "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/dso1agwu_22.jpeg",
  "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/vu09vpr6_15.jpeg",
  "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/uxrzq4f3_23.jpeg",
  "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/w9kkuh54_24.jpeg"
];

export const TOUR_IMAGES = [
  "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/fdpc4i18_toru%20napoli.jpg",
  "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/56dpgoua_costiera-amalfitana-.webp",
  "https://customer-assets.emergentagent.com/job_napoli-tours-1/artifacts/6klawbii_Costiera-Sorrentina%202.jpg"
];

// Contact info
export const CONTACT = {
  phone: "+39 339 5819593",
  phoneRaw: "+393395819593",
  whatsapp: "393395819593",
  email: "bebimaestri@gmail.com",
  address: "Via dei Tribunali 257, 80139 Napoli",
  bookingUrl: "https://www.booking.com/hotel/it/beb-i-maestri.it.html?label=gen173bo-10CAsocUINYmViLWktbWFlc3RyaUgzWANocYgBAZgBM7gBF8gBDNgBA-gBAfgBAYgCAZgCBqgCAbgCjOnf0QbAAgHSAiQxOGU4YjhiNy1iNjM3LTRlMjktODdlMC00YjAwMGQ2YmY3NDDYAgHgAgE&sid=350cd785f725fc918c3764df85371eb6&dist=0&group_adults=2&group_children=0&no_rooms=1&sb_price_type=total&type=total",
  airbnbUrl: "https://www.airbnb.com/rooms/1252562202537727965"
};
